import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export async function deleteAgentHoliday(scheduleId: number): Promise<void> {
  return axios.delete(`${API_URL}/api/crm/agents-schedule/${scheduleId}/`);
}
